import PublicContentBase from '../../ContentBase'
import './Styles.scss'

const PublicContentVaultLink = (): JSX.Element => {
    return <PublicContentBase />
}

export default PublicContentVaultLink
